module.exports = __webpack_public_path__ + "static/media/play.b6021751.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play.png
// module id = 543
// module chunks = 0